import { Select, Empty } from 'antd';
import IDown from '@imgs/icons/down.svg';
import IClear from '@imgs/icons/clear.svg';

export default function ResetSelect(props: any) {
  const { children } = props;
  return (
    <Select
      suffixIcon={<IDown className='select-icon-down' />}
      notFoundContent={<Empty description='无匹配结果' />}
      clearIcon={<IClear />}
      {...props}
    >
      {children}
    </Select>
  );
}
